import { ProjectFilters } from '@/data/services/projectServices';
import { isSuperAdmin } from '@/functions/auth';
import { FlagTypeEnum } from '@/models/Flag';
import { StageTypeEnum } from '@/models/Hackathon';
import { getCurrentStage } from '@/utils/hackathon';
import useAuth from '../useAuth';
import useHackathon from './useHackathon';

const useHackathonFilters = (): ProjectFilters => {
  const { hackathon, hackathonsStages, isFinish } = useHackathon();
  const { user } = useAuth();
  const currentState = getCurrentStage(hackathonsStages);

  if (!hackathon) return {};
  const falseyToUndefined = (value: any) => value || undefined;
  const shunfle =
    !isFinish &&
    !isSuperAdmin(user?.userType) &&
    currentState?.type !== StageTypeEnum.SUBMISSION;

  const byUpVotes = isSuperAdmin(user?.userType) || isFinish;
  const flagsType = currentState?.type === StageTypeEnum.FINAL_VOTING;

  return {
    flagsId: [hackathon.flagId],
    flagsType: falseyToUndefined(flagsType && [FlagTypeEnum.FINALIST]),
    byUpVotes: falseyToUndefined(byUpVotes && 'more'),
    shunfle: falseyToUndefined(shunfle),
  };
};

export default useHackathonFilters;
